import type { UsePersistedBlotterTable } from '@talos/kyoko';
import { useDateAndQuickTextFilter } from './useDateAndQuickTextFilter';

interface UseCreditExposuresFilterParams {
  persistedBlotterTable: UsePersistedBlotterTable;
}

export function useCreditExposuresFilter({ persistedBlotterTable }: UseCreditExposuresFilterParams) {
  return useDateAndQuickTextFilter({ persistedBlotterTable });
}
